export default "__VITE_ASSET__D5H_$EYj__"